import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {BUTTON_PRIMARY, SUCCESS} from '../assets/constants/Constants';
import ButtonComponent from '../components/ButtonComponent';
import { useLocation } from "react-router-dom";
import DuroltLogo from "../assets/images/durolt_logo_new.svg";
import { getAssignedLockerList } from '../api/api';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import {LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS } from '../assets/constants/BrowserStorageKeys';
import CircularProgressLoader from '../components/CircularProgressLoader';
import { buildInvoiceList, getUnitLabelParams, getHeaderImage, getFooterImage, fetchPaymentGatewayDetails } from '../lib/Utils';

// Builds a bank-type list aligned with buildInvoiceList's flatMap order,
// so each invoice can be paired with the bank type of the booking it came from.
const buildInvoiceBankTypes = (lockers = []) =>
	(lockers || []).flatMap((item) =>
		(item?.payment_records || []).map(
			() => item?.locker_bank?.bank_type ?? item?.LockerBankType
		)
	);

const InvoicePage = () => {
	const { t } = useTranslation();
	const [showLoader, setShowLoader] = useState(false);
	const [loadingMessage, setLoadingMessage] = useState(t('Loading'));
	const location = useLocation();
	const settings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS)
	const {lockerItem } = location.state || {};
	const [invoices, setInvoices] = useState([]);
	console.log("InvoicePage: lockerItem:", lockerItem);


	useEffect(() => {
		const init = async () => {
			setShowLoader(true);
			setLoadingMessage(t('loading'));
			if (lockerItem) {
			const invoiceList = buildInvoiceList([lockerItem]);
			const bankTypes = buildInvoiceBankTypes([lockerItem]);
			const paymentGatewayDetails = await fetchPaymentGatewayDetails(lockerItem?.BankID || lockerItem?.locker_bank?.id);
			setInvoices(invoiceList.map((inv, idx) => ({ ...inv, bank_type: bankTypes[idx], ...paymentGatewayDetails })));
			setShowLoader(false);
			setLoadingMessage("");
			return;
			}
			setInvoices([]);
			setShowLoader(false);
			setLoadingMessage("");
		};
		init();
}, [lockerItem, settings?.id]);

	const handlePrint = () => {
		window.print();
	};

	const isSingleInvoice = invoices.length === 1;

	return (
		<div className="invoice-page">
			{invoices.length >= 1 ? (
				<>
				{invoices.map((inv, idx) => (
					<div className="invoice-card" key={inv.invoice_no || idx}>
					<div className="invoice-header">
						<div className="image-container">
						<img
							src={getHeaderImage(t, inv?.paymentImage, DuroltLogo)}
							alt={t("durolt_logo")}
							className="header-image"
						/>
						</div>
						<div className="text-container">
							<p className="company-title">{inv?.businessName}</p>
							<p className="company-address">{inv?.invoiceAddress}</p>
						</div>
					</div>

					<hr />

					<div className="invoice-details">
						<div className="detail-row"><span className="detail-label">{t("invoice_date_label")}</span><span className="detail-value">{inv.date}</span></div>
						<div className="detail-row"><span className="detail-label">{t("invoice_time_label")}</span><span className="detail-value">{inv.time}</span></div>
						<div className="detail-row"><span className="detail-label">{t("invoice_number_label")}</span><span className="detail-value">{inv.invoice_no}</span></div>
						<div className="detail-row"><span className="detail-label">{t("invoice_payment_id_label")}</span><span className="detail-value">{inv.payment_id}</span></div>
						<div className="detail-row"><span className="detail-label">{t("invoice_locker_bank_label", getUnitLabelParams(inv.bank_type, t))}</span><span className="detail-value">{inv.locker_bank}</span></div>
						<div className="detail-row"><span className="detail-label">{t("invoice_payment_method_label")}</span><span className="detail-value">{inv.payment_method}</span></div>
						<div className="detail-row"><span className="detail-label">{t("invoice_customer_id_label")}</span><span className="detail-value">{inv.customer_id}</span></div>
					</div>

					<div className="amount">
						{inv.currency} <span>{inv.amount}</span>
					</div>

					<div className="rental-details">
						<p className="signature">{t("invoice_signature_not_required")}</p>
						<p className="agreement">
						{t("invoice_agreement_text")}
						</p>
					</div>

					<hr />

					<div className="invoice-footer">
						<div className="copy">{t("invoice_customer_copy")}</div>
						<img
							src={getFooterImage(t, inv?.invoiceFooterImage, DuroltLogo)}
							alt={t("durolt_logo")}
							className="footer-image"
						/>
					</div>

					{isSingleInvoice && (
						<ButtonComponent
						buttonId="print-invoice-button"
						handleClick={handlePrint}
						title={"print_Invoice"}
						type={BUTTON_PRIMARY}
						/>
					)}
					</div>
				))}

				{!isSingleInvoice && invoices.length > 1 && (
					<div className="print-btn-wrapper global-print-btn">
					<ButtonComponent
						buttonId="print-all-invoices"
						handleClick={handlePrint}
						title={"print_All_Invoices"}
						type={BUTTON_PRIMARY}
					/>
					</div>
				)}
				</>
			) : !showLoader && (
				<p className="no-invoice-text">
				{t("noInvoicesAvailable")}
				</p>
			)}

			{showLoader && <CircularProgressLoader message={loadingMessage} />}
	</div>
	);
};

export default InvoicePage;
